import {
    FETCH_NGOS,
    FETCH_NGOS_SUCCESS,
    FETCH_NGOS_FAILED,
    EDIT_NGO
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { get, push, set, remove } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";

// One slice serves both apps: the portal manages the catalog, the mobile
// Donate screen lists it. One-shot get — no listeners (RTDB cost rule).
export const fetchNgos = () => async (dispatch) => {
    const { ngosRef } = firebase;

    dispatch({
        type: FETCH_NGOS,
        payload: null
    });
    try {
        const snapshot = await get(ngosRef);
        if (snapshot.val()) {
            const data = snapshot.val();
            // No active-filter here: the portal manages inactive NGOs too.
            // The mobile Donate screen filters to active === true itself.
            const arr = Object.keys(data).map(i => {
                data[i].id = i;
                return data[i];
            });
            arr.sort((a, b) => ((a.order ?? 9999) - (b.order ?? 9999)) || String(a.name).localeCompare(String(b.name)));
            dispatch({
                type: FETCH_NGOS_SUCCESS,
                payload: arr
            });
        } else {
            dispatch({
                type: FETCH_NGOS_SUCCESS,
                payload: []
            });
        }
    } catch (error) {
        dispatch({
            type: FETCH_NGOS_FAILED,
            payload: error.message
        });
    }
};

// Individual donation ledger rows (admin/finance). fromTs bounds the read
// by date (indexed); pass null/undefined for all-time. Returns newest-first
// [{id, ngoId, uid, miles, etbValue, rate, date, historyKey}].
export const fetchNgoDonations = async (fromTs) => {
    const { ngoDonationsByDateRef } = firebase;
    const snapshot = await get(ngoDonationsByDateRef(fromTs));
    const data = snapshot.val() || {};
    const arr = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i];
    });
    arr.sort((a, b) => (b.date || 0) - (a.date || 0));
    return arr;
};

// Per-NGO donation tallies from server-only /ngo_stats — keyed by ngoId:
// { miles, donationCount, etbValue, lastDonationAt }. Tiny node; plain
// promise helper (no redux) like fetchPhoneCardsMeta.
export const fetchNgoStats = async () => {
    const { ngoStatsRef } = firebase;
    const snapshot = await get(ngoStatsRef);
    return snapshot.val() || {};
};

// Promise helper so views can compose upload + record update themselves
// (cleaner than the editCarType 'UpdateImage' method-string style).
export const uploadNgoImage = async (id, file) => {
    const { ngoImageRef } = firebase;
    await uploadBytesResumable(ngoImageRef(id), file);
    return getDownloadURL(ngoImageRef(id));
};

// 'Add' returns the new push key so the caller can upload the image against
// it and then 'Update' the record with the URL.
export const editNgo = (ngo, method) => async (dispatch) => {
    const { ngosRef, ngoEditRef } = firebase;
    dispatch({
        type: EDIT_NGO,
        payload: { method, ngo }
    });
    if (method === 'Add') {
        const newRef = push(ngosRef);
        await set(newRef, ngo);
        return newRef.key;
    } else if (method === 'Delete') {
        await remove(ngoEditRef(ngo.id));
        return ngo.id;
    } else {
        const data = { ...ngo };
        delete data.id;
        delete data.tableData;
        await set(ngoEditRef(ngo.id), data);
        return ngo.id;
    }
};
